import { useEffect, useState } from 'react';
import {
  getAmhsKitTemplateRevision,
  subscribeAmhsKitTemplates,
} from './amhsKitTemplateStore';

/** Re-render instanced layers when off-screen kit capture finishes. */
export function useAmhsKitTemplateRevision(): number {
  const [revision, setRevision] = useState(getAmhsKitTemplateRevision);
  useEffect(() => {
    return subscribeAmhsKitTemplates(() => {
      setRevision(getAmhsKitTemplateRevision());
    });
  }, []);
  return revision;
}
